<template>
  <el-dialog
    title="验证公司"
    :visible="visible"
    width="480px"
    @close="handleClose"
  >
    <el-form label-width="80px" :rules="rules" :model="editForm" ref="editForm">
      <el-row>
        <el-form-item label="公司全称" prop="name">
          <el-input
            size="small"
            v-model="editForm.name"
            placeholder="公司全称"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleConfirm"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请输入公司名", trigger: "blur" }],
      },
    };
  },
  methods: {
    handleConfirm() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$emit("confirm", this.editForm.name);
          this.$refs.editForm.resetFields();
          this.$emit("update:visible", false);
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
      this.$emit("close");
    },
  },
};
</script>

 
 

 


// WEBPACK FOOTER //
// src/components/company.vue